import axios from "../../utils/axios";

export const getBlogs = async ({ sorting, filtering }) => {
    let queryString = "";
    // _sort=votes&_order=asc
    if (sorting === "most_liked") {
        queryString += `&_sort=likes&_order=desc`;
    }
    if (sorting === "newest") {
        queryString += `&_sort=createdAt&_order=desc`;
    }
    if (filtering === "saved") {
        queryString += `&isSaved=true`;
    }

    const response = await axios.get(`/blogs?${queryString}`);

    return response.data;
};
